<template>
  <div data-testid="alert" :class="`page-editor-alert page-editor-alert--${variant} page-editor-alert--${size}`">
    <i
      v-if="icon && icon.length"
      data-testid="alert-icon"
      :class="`fal fa-${icon} page-editor-alert__icon page-editor-alert__icon--${variant}`"
    />

    <div v-html="text" data-testid="alert-text" class="page-editor-alert__content" />
  </div>
</template>

<script>
export default {
  name: 'PageEditorAlert',
  props: {
    variant: {
      type: String,
      default: 'success',
    },
    size: {
      type: String,
      default: 'medium',
    },
    text: {
      type: String,
      default: '',
    },
    icon: {
      type: String,
      default: '',
    },
  },
}
</script>

<style lang="scss" scoped>
.page-editor-alert {
  display: flex;
  border-radius: 2px;
}

.page-editor-alert--medium {
  padding: 16px;
}

.page-editor-alert--small {
  padding: 4px;
}

.page-editor-alert--success {
  background-color: $pale-cyan;
  border-left: 2px solid $cyan-hover;
}

.page-editor-alert--warning {
  background-color: $yellow-light-02;
  border-left: 2px solid $yellow-dark;
}

.page-editor-alert--danger {
  background-color: #feb4b4;
  border-left: 2px solid $cherry;
}

.page-editor-alert--info {
  background-color: #bacdff;
  border-left: 2px solid #2257ce;
}

.page-editor-alert__icon {
  margin-right: 8px;
}

.page-editor-alert__icon--success {
  color: $cyan-hover;
}

.page-editor-alert__icon--warning {
  color: $yellow-dark;
}

.page-editor-alert__icon--danger {
  color: $cherry-dark;
}

.page-editor-alert__content {
  color: $grey;
  font-size: 0.75rem;
  line-height: 1.25rem;
}
</style>
